module.exports = __webpack_public_path__ + "static/img/juejin.6a177546.png";